<template>
  <a-modal
    title="Edit Bank Account"
    :visible="modalEditBankAccount"
    @ok="handleModalEditOk"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    okText="Save"
    cancelText="Cancel"
  >
    <div class="m-card-body">
      <ul class="m-list-wrapper bordered">
        <li>
          <span class="m-list-title" for>No.</span>
          <span class="m-list-desc">{{ dataSource.no_trans }}</span>
        </li>
        <li>
          <span class="m-list-title" for>Description</span>
          <span class="m-list-desc">{{ dataSource.description }}</span>
        </li>
      </ul>
    </div>
    <a-form :form="form" class="margin-top">
      <a-form-item label="Bank Account">
        <a-input
          v-decorator="['bank_account', {rules: [{required: true}], initialValue: dataSource.bank_nm}]"
        ></a-input>
      </a-form-item>
      <a-form-item label="Account Number">
        <a-input
          v-decorator="['account_number', {rules: [{required: true}], initialValue: dataSource.bank_rek}]"
        ></a-input>
      </a-form-item>
      <a-form-item label="Owner">
        <a-input
          v-decorator="['owner', {rules: [{required: true}], initialValue: dataSource.bank_an}]"
        ></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import HandleMessage from "@/mixins/HandleMessage";
export default {
  name: "DialogBankAccount",
  props: [
    "modalEditBankAccount",
    "dataSource",
    "confirmLoading"
  ],
  mixins: [GlobalMethod, HandleMessage],
  computed: {
    ...mapGetters([
      'getAuth'
    ])
  },
  created(){
    this.form = this.$form.createForm(this);
  },
  mounted(){
  },
  methods:{
    handleModalEditOk(){
      this.form.validateFields((err, val) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let data = new FormData();
        data.append("id", this.dataSource.id);
        data.append("jenis", this.dataSource.jenis);
        data.append("bank_nm", val.bank_account);
        data.append("bank_rek", val.account_number);
        data.append("bank_an", val.owner);

        Event.$emit("actionSubmitModalEditBankAccount", true);
        this.asyncAxiosPost(
          "bkk/no_rekening",
          "formdata",
          this.getAuth,
          data
        )
          .then(() => {
            this.displayMessage("success-save");
            Event.$emit("actionSubmitModalEditBankAccount", false);
            Event.$emit("reloadTabs", true);
            this.handleCancel()
          })
          .catch((err) => {
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              this.displayMessageValue("error-other", response.data.message);
            } else {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
            }
          });
      })
    },
    handleCancel(){
      Event.$emit("modalEditBankAccountCancel", false);
    }
  }
}
</script>